import { useContext } from 'react';
import { SurveyBuilderOptionsContext, SurveyBuilderStateContext } from '@containers/SurveyBuilder/Context';

export const useSurveyBuilderState = () => useContext(SurveyBuilderStateContext);
export const useSurveyBuilderOptions = () => useContext(SurveyBuilderOptionsContext);